import React from 'react'
import type { CalendarEvent } from 'paintscout'
import { ProjectsByManager } from './ProjectsByManager'
import { makeStyles } from '@material-ui/core'
import { Typography, useClientOptions } from '@paintscout/ui'
import { getCrews } from '@paintscout/util/builder'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  noProjects: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.typography.pxToRem(120),
    border: `1px solid ${theme.paintscout.palette.brand.Neutral.P90}`,
    borderRadius: theme.borderRadius.md
  }
}))

export function DayView(props) {
  const { events, date }: { events: CalendarEvent[]; date: Date } = props
  const classes = useStyles()
  const { options } = useClientOptions()
  const crews = getCrews({ options })

  const filteredEvents = events.filter((event) => {
    // show the events that start, end or span the current date
    const eventStart = new Date(event.start)
    const eventEnd = new Date(event.end)
    return (
      (eventStart <= date && eventEnd >= date) ||
      eventStart.toDateString() === date.toDateString() ||
      eventEnd.toDateString() === date.toDateString()
    )
  })

  const eventsByProjectManager = filteredEvents.reduce(
    (grouped, event) => {
      const crewId = event.crew || 'unassigned'
      const crew = crews.find((c) => c._id === crewId)
      const managerId = crew?.projectManager?.id || 'unassigned'

      if (!grouped[managerId]) {
        grouped[managerId] = []
      }
      grouped[managerId].push(event)
      return grouped
    },
    {} as Record<string, CalendarEvent[]>
  )

  if (filteredEvents.length === 0) {
    return (
      <div className={classes.root}>
        <Typography color="textSecondary" className={classes.noProjects}>
          No jobs scheduled for this day
        </Typography>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {Object.entries(eventsByProjectManager).map(([managerId, events]) => (
        <ProjectsByManager key={managerId} events={events} />
      ))}
    </div>
  )
}
